import { css } from '@compiled/react';

export const CreateYourAccount = () => <h2 css={headingCss}>Create your account</h2>;

const headingCss = css({
	fontSize: '1.25rem',
	fontWeight: 500,
	letterSpacing: '.3px',
	lineHeight: 1.2,
	marginBlockStart: 0,
	marginBlockEnd: 30,
});
